import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DataService } from '../../../services/data.service';
import { TaxesFeeSetup } from '../../../POS/models/taxes-fee-setup';
import { PaymentSetup } from '../../../POS/models/payment-setup';
import { PaymentReceiptSetup } from '../../../POS/models/payment-receipt-setup';
import { CommonFunctionService, UserPOSData} from '../../../services/Common/common-function.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  userId: any;
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient,private common:CommonFunctionService) { 
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
  }
  
  GetPaymentReceiptDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<PaymentReceiptSetup>(environment.GetPaymentReceiptDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId,{headers:this.headers})
    .pipe(map(response => response));
  }
  AddPaymentReceipt(data)
  {
    this.GetGeaderdetails();
    return this.http.post(environment.AddPaymentReceiptUrl, data,{headers:this.headers});
  }

  AddOrderReceipt(data)
  {
    this.GetGeaderdetails();
    return this.http.post(environment.AddPaymentReceiptUrl, data,{headers:this.headers});
  }

  UpdateOrderReceipt(data) {
    this.GetGeaderdetails();
    // return this.service.put(
    //   environment.UpdatePaymentReceiptUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.PaymentReceiptId,data );
     return this.http.post(
      environment.UpdatePaymentReceiptUrl ,data ,{headers:this.headers});

  }


  GetPaymentSetupDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<PaymentSetup>(environment.GetPaymentSetupDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+ data.id,{headers:this.headers})
    .pipe(map(response => response));
  }

  AddPaymentSetup(data)
  {
    this.GetGeaderdetails();
    return this.http.post(environment.AddPaymentSetupUrl, data ,{headers:this.headers});
  }

  UpdatePaymentSetup(data) {
    this.GetGeaderdetails();
    // return this.service.put(
    //   environment.UpdatePaymentSetupUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.PaymentSetupId,data );
    return this.http.post(
      environment.UpdatePaymentSetupUrl ,data ,{headers:this.headers});

  }
  
  GetGeaderdetails()
  {
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));

  }

  // PaymentSetupDetailList(data) {
  //   return this.service
  //     .getAll(environment.PaymentSetupDetailListUrl + "?PosSubscriptionId=" + data.PosSubscriptionId)
  //     .map(response => response);
  // }
}
